import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import AntIcon from './AntIcon';

const Sidebar = ({ userRole }) => {
  return (
    <Layout.Sider
      breakpoint="lg"
      collapsedWidth="0"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div className="logo">
        <Link to="/" className="ic-logo" />
      </div>

      <Menu
        theme="dark"
        selectedKeys={[ window.location.pathname.split("/")[1] ]}
        style={{ flex: 1 }}
      >
        <Menu.Item key="releases">
          <Link to="/releases"><AntIcon type="calendar" />Releases</Link>
        </Menu.Item>
        <Menu.Item key="posts">
          <Link to="/posts"><AntIcon type="snippets" />Posts</Link>
        </Menu.Item>
        <Menu.Item key="catalog">
          <Link to="/catalog"><AntIcon type="folder" />Catalog</Link>
        </Menu.Item>
        <Menu.Item key="model">
          <Link to="/model"><AntIcon type="folder" />Model</Link>
        </Menu.Item>
        <Menu.Item key="tags">
          <Link to="/tags"><AntIcon type="tags" />Tags</Link>
        </Menu.Item>
        <Menu.Item key="news">
          <Link to="/news"><AntIcon type="layout" />News</Link>
        </Menu.Item>
        <Menu.Item key="featured">
          <Link to="/featured"><AntIcon type="star" />Featured</Link>
        </Menu.Item>
        <Menu.Item key="keywords">
          <Link to="/keywords"><AntIcon type="form" />Keywords</Link>
        </Menu.Item>
        <Menu.Item key="raffles">
          <Link to="/raffles"><AntIcon type="trophy" />Raffles</Link>
        </Menu.Item>
        <Menu.Item key="giveaway">
          <Link to="/giveaway"><AntIcon type="gift" />Giveaway</Link>
        </Menu.Item>

        {userRole === 'admin' && (
          <Menu.Item key="editors">
            <Link to="/editors"><AntIcon type="edit" />Editors</Link>
          </Menu.Item>
        )}

        <Menu.Item key="settings">
          <Link to="/settings"><AntIcon type="setting" />Settings</Link>
        </Menu.Item>
      </Menu>

      <div style={{ padding: 12, color: 'rgba(255,255,255,0.45)', fontSize: 12, textAlign: 'center' }}>
        v0.0.1
      </div>
    </Layout.Sider>
  );
}

Sidebar.propTypes = {
  userRole: PropTypes.string.isRequired
};

export default Sidebar;
